import { type BuySeatStepProps, BuySeatStep } from './BuySeatStep'

const BUY_SEAT_STEP_TITLE = 'Buy a seat'

export interface BuySeatStepModalProps extends BuySeatStepProps {
  onDismiss: () => void
}

export const buySeatStepModalProps = ({ firstLine, secondLine, buy, onDismiss }: BuySeatStepModalProps) => ({
  header: <h4>{BUY_SEAT_STEP_TITLE}</h4>,
  body: <BuySeatStep firstLine={firstLine} secondLine={secondLine} buy={buy} />,
  footer: undefined,
  showFooterActions: true,
  onFooterPrimaryAction: buy.confirm,
  footerPrimaryActionTitle: 'Confirm',
  footerPrimaryActionLoading: buy.isConfirming,
  footerPrimaryActionDisabled: buy.isBought,
  footerSecondaryActionDisabled: buy.isConfirming,
  onFooterSecondaryAction: onDismiss,
  onHide: () => {
    if (!buy.isConfirming) {
      onDismiss()
    }
  },
})
